"use client";

import { useState } from "react";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { MitgliedDialog } from "./mitglied-dialog";

export function NeuesMitgliedKnopf() {
  const [offen, setOffen] = useState(false);
  return (
    <>
      <Button onClick={() => setOffen(true)}>
        <Plus className="h-4 w-4" aria-hidden />
        Mitglied anlegen
      </Button>
      <MitgliedDialog open={offen} onClose={() => setOffen(false)} />
    </>
  );
}
